export const TIME_SPENT_INCREMENT_MINUTES = 15;

export const TIME_SPENT_VALIDATION_MESSAGE =
  'Time spent must be in 15-minute increments (15, 30, 45, 60, etc.)';

export function isValidTimeSpentMinutes(value: number): boolean {
  return (
    Number.isInteger(value) &&
    value >= TIME_SPENT_INCREMENT_MINUTES &&
    value % TIME_SPENT_INCREMENT_MINUTES === 0
  );
}

export function getTimeSpentValidationError(value: string): string | undefined {
  const minutes = parseInt(value, 10);
  if (!value || isNaN(minutes) || !isValidTimeSpentMinutes(minutes)) {
    return TIME_SPENT_VALIDATION_MESSAGE;
  }
  return undefined;
}
